'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var fieldLabel = require('./field-label-4ed9b7f8.js');
var FormControlLabel = _interopDefault(require('@material-ui/core/FormControlLabel'));
var loader = require('./loader-f28c8bde.js');

var LoaderContainer = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  padding-left: 13\n"], ["\n  padding-left: 13\n"])));
var loaderSize = {
    small: '16px',
    medium: '20px',
};
var StyledFieldLabel = styled__default(fieldLabel.FieldLabel)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font-weight: normal;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: 17px;\n  cursor: ", ";\n"], ["\n  font-weight: normal;\n  font-family: ", ";\n  font-size: ", ";\n  line-height: 17px;\n  cursor: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.fontSizes.sm;
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
var CheckboxWrapper = function (_a) {
    var _b = _a.clipLoaderSize, clipLoaderSize = _b === void 0 ? 'medium' : _b, _c = _a.labelPlacement, labelPlacement = _c === void 0 ? 'end' : _c, required = _a.required, disabled = _a.disabled, loading = _a.loading, _d = _a.title, title = _d === void 0 ? '' : _d, children = _a.children;
    return (loading ? (React__default.createElement(LoaderContainer, null,
        React__default.createElement(loader.Loader, { size: loaderSize[clipLoaderSize], color: "currentColor" }))) : (React__default.createElement(FormControlLabel, { labelPlacement: labelPlacement, label: (React__default.createElement(StyledFieldLabel, { label: title, required: required, disabled: disabled })), control: children })));
};
var templateObject_1, templateObject_2;

var StyledFieldLabel$1 = styled__default(fieldLabel.FieldLabel)(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  cursor: ", ";\n"], ["\n  cursor: ", ";\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 'not-allowed' : 'pointer');
});
var SwitchFieldWrapper = function (_a) {
    var _b = _a.labelPlacement, labelPlacement = _b === void 0 ? 'end' : _b, required = _a.required, disabled = _a.disabled, _c = _a.title, title = _c === void 0 ? '' : _c, children = _a.children;
    return (React__default.createElement(FormControlLabel, { labelPlacement: labelPlacement, label: (React__default.createElement(StyledFieldLabel$1, { label: title, required: required, disabled: disabled })), control: children }));
};
var templateObject_1$1;

exports.CheckboxWrapper = CheckboxWrapper;
exports.LoaderContainer = LoaderContainer;
exports.SwitchFieldWrapper = SwitchFieldWrapper;
exports.loaderSize = loaderSize;
